function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * @file 禁用存储cookie、storage等可用性
 * @author leibin<leibin@baijia.com>
 * @module util/detectStorageAvailability
 */

import isClient from './detectClient';

/**
 * 禁用cookie检测
 * @return {boolean} cookie 是否可用
 */
export function areCookiesEnabled() {
  var cookieEnabled = true;
  try {
    cookieEnabled = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === 'object' && navigator.cookieEnabled;
    if (!cookieEnabled) {
      // 尝试设置和读取一个临时的cookie
      document.cookie = 'testcookie=testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
  } catch (e) {
    cookieEnabled = false;
  }
  return cookieEnabled;
}

/**
 * 探测 localStorage,sessionStorage 可用性, 隐私模式下，storage、cookie都不可用
 * @param {boolean} 是否在客户端环境
 */
export var detectStorage = function detectStorage() {
  var storageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
  var canUseStorage = isClient;
  try {
    isClient && window[storageName].getItem('try');
  } catch (e) {
    canUseStorage = false;
  }
  return canUseStorage;
};